import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { apiSlice } from './api/apiSlice';
import { gameApiSlice } from '../features/game/gameApiSlice'; 
import authReducer from '../features/auth/authSlice';
import runningGameReducer from '../features/running-game/runningGameSlice';
import uiReducer from '../features/ui/uiSlice';
import animatorReducer from '../features/animator/animatorSlice';
import adminReducer from '../features/admin/adminSlice';
import buyerReducer from '../features/buyer/buyerSlice';
import { rtkQueryErrorMiddleware } from './middleware/rtkQueryErrorMiddleware';

// Import the API slices to ensure they are injected
import '../features/buyer/buyerApiSlice';
import '../features/animator/animatorApiSlice';
import '../features/admin/adminApiSlice'; 

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [gameApiSlice.reducerPath]: gameApiSlice.reducer,
    auth: authReducer,
    runningGame: runningGameReducer,
    ui: uiReducer,
    animator: animatorReducer,
    admin: adminReducer,
    buyer: buyerReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(apiSlice.middleware)
      .concat(gameApiSlice.middleware)
      .concat(rtkQueryErrorMiddleware), 
  devTools: true,
});

setupListeners(store.dispatch);
